export const ORDERS_COUNT_BY_EMAIL = 'mac/FETCH_ORDERS_COUNT_BY_EMAIL';
export const QUOTES_POST = 'mac/FETCH_QUOTES_POST';
export const SEARCH_FOR_CONTACT_POST = 'mac/FETCH_SEARCH_FOR_CONTACT_POST';
export const LATEST_REFUND = 'mac/FETCH_LATEST_REFUND';
export const REFUND_PDF = 'mac/FETCH_REFUND_PDF';
export const INVOICE_PDF = 'mac/FETCH_INVOICE_PDF';
export const JSON_GET = 'mac/FETCH_JSON';
